/**
 * Project distance units. They label values and reports only; coordinates
 * are never converted. Values match the project-file whitelist.
 */
export const UNIT_OPTIONS: ReadonlyArray<{
  value: string;
  label: string;
  /** Compact form for chips and table headings. */
  short: string;
}> = [
  { value: 'unspecified', label: 'Not specified', short: 'No units' },
  { value: 'm', label: 'Metres', short: 'm' },
  { value: 'international ft', label: 'International feet', short: 'ft' },
  { value: 'US survey ft', label: 'US survey feet', short: 'US ft' },
];

export const isUnitsSpecified = (units: string): boolean =>
  units !== '' && units !== 'unspecified';

/** Full label for a stored units value, e.g. "US survey feet". */
export const getUnitsLabel = (units: string): string =>
  UNIT_OPTIONS.find((option) => option.value === units)?.label ?? units;
